import { Box, Button, Typography } from "@mui/material";
import { useApplyCoupon } from "@mutations/useApplyCoupon";

export default function ApplyCouponButton() {
  const { mutate, data, isPending, isError, isSuccess, error } = useApplyCoupon();

  const handleCreatePurchase = () => {
    mutate({
      promoCode: "Test10",
      cartProducts: [{ sku: "sspCertification" }],
    });
  };

  return (
    <Box sx={{ p: "24px" }}>
      <Button onClick={handleCreatePurchase} variant="contained">
        {isPending ? "Applying..." : "Apply Coupon"}
      </Button>

      {isSuccess && (
        <Typography sx={{ mt: "16px", color: "green" }}>
          ✅ Success! data: {JSON.stringify(data)}
        </Typography>
      )}

      {isError && (
        <Typography sx={{ mt: "16px", color: "red" }}>
          ❌ Error: {(error as Error).message}
        </Typography>
      )}
    </Box>
  );
}
